import './fb-script.css';
import { searchEcFormBuilderController } from '../../controller/searchEcFormBuilderController';
import { fbScriptHelpTemplate } from './fb-script-help-template';

fbScriptDirective.$inject = ['ecNotificationsService', '$translate', '$compile', '$timeout'];

export default function fbScriptDirective(ecNotificationsService, $translate, $compile, $timeout) {
  return {
    restrict: 'E',
    template: (elem, attrs) => {
      // hay que forzar el padre del ec-editor a style="overflow: visible"
      return `<div ec-fullscreen="isFullscreen" ec-layout ng-init="editorApi={};" style="overflow: visible">
      <ec-toolbar>
        <span>{{::label}}</span>
        <ec-group>
          <ec-button title="{{::'fbScript.undo'|translate}}" icon="arrow-rotate-left" click="undo()"></ec-button>
          <ec-button title="{{::'fbScript.redo'|translate}}" icon="arrow-rotate-right" click="redo()"></ec-button>
        </ec-group>
        <ec-space></ec-space>
        ${
          attrs.scriptHelp
            ? `<ec-button role="popover" fullscreen-btn compile="false" click="getHelp()" title="{{::'fbScript.help'|translate}}" icon="circle-question">
          <div help-script style="height: 60vh; width: 480px; display: flex;"></div>
        </ec-button>`
            : ''
        }
        ${
          attrs.scriptValidator
            ? `<ec-button click="validateScript()" title="{{::'fbScript.validate'|translate}}" icon="check">
        </ec-button>`
            : ''
        }
        <ec-button ng-if="!!variables && !!variables.length" role="popover" compile="always" title="{{::'fbScript.insertVariable'|translate}}" icon="plus">
          <fb-script-variables-button insert="insert" variables="variables"></fb-script-variables-button>
        </ec-button>
        <ec-button title="{{::'fbScript.search'|translate}}" icon="magnifying-glass" click="find()"></ec-button>
        <ec-button ng-show="isFullscreen" icon="down-left-and-up-right-to-center" click="setFullScreen()" title="{{:: 'ecPdf.minimize' | translate}}"></ec-button>
        <ec-button ng-show="!isFullscreen" icon="up-right-and-down-left-from-center" click="setFullScreen()" title="{{:: 'ecPdf.maximize' | translate}}"></ec-button>
        <span role="help-max"></span>
      </ec-toolbar>
      <ec-editor ${attrs.maxlength ? `maxlength="${attrs.maxlength}"` : ''} ng-model="ngModel" language="ediwinscript" theme="ediwinscript"></ec-editor>
    </div>
    `;
    },
    scope: {
      ngModel: '=',
      label: '@',
      scriptHelp: '=',
      scriptValidator: '=',
      functionCompletion: '=',
    },
    require: '^^?ecFormBuilder',
    link,
  };

  function link(scope, element, attrs, ecFormBuilderController) {
    try {
      ecFormBuilderController = ecFormBuilderController || searchEcFormBuilderController(scope);
    } catch (e) {
      console.error('fbScript', e, element[0]);
    }
    const elem = element[0];
    const elemEcMonaco = elem.querySelector('ec-monaco'),
      elemEcEditor = elem.querySelector('ec-editor');
    const eHelpMax = elem.querySelector('[role="help-max"]');
    let fakeButtons;
    let eFilterList;
    let eMenuSwap;
    let LOCALES;
    const unbinds = [];

    try {
      scope.variables = attrs.variables ? JSON.parse(attrs.variables) : null;
    } catch (e) {
      throw new Error('fbScriptDirective: argument variables incorrect.');
    }

    attrs.maxlength && elemEcMonaco.addEventListener('ecMonaco:input', onChangeInput);

    scope.$on('$destroy', function() {
      attrs.maxlength && elemEcMonaco.removeEventListener('ecMonaco:input', onChangeInput);
      fakeButtons && fakeButtons.forEach(button => button.removeEventListener('click', onAddFunction));
      unbinds.forEach(unbind => unbind());
    });

    scope.undo = () => elemEcEditor.undo();
    scope.redo = () => elemEcEditor.redo();
    scope.find = () => elemEcEditor.openFind();
    scope.insert = param => elemEcEditor.insert(param);
    scope.setFullScreen = () => {
      scope.isFullscreen = !scope.isFullscreen;
      scope.isFullscreen && elemEcEditor.refreshSize();
    };
    scope.getHelp = getHelp;
    scope.validateScript = validateScript;
    scope.showFunctionsList = false;
    scope.searchFunction = '';
    $timeout(() => getFunctionCompletion());

    translate();

    function onChangeInput() {
      attrs.maxlength && updateLength();
    }

    // actualiza el contador de caracteres
    function updateLength() {
      const length = elemEcMonaco.getAttribute('length');
      elem.setAttribute('length', length);
      eHelpMax.innerHTML = `${length}/${attrs.maxlength}`;
    }

    function getFunctionCompletion() {
      const fn = scope.functionCompletion ? scope.functionCompletion : ecFormBuilderController.dispatcher.get(attrs.functionCompletion);
      if (fn) {
        elemEcEditor.setCompletionItems(fn);
      }
    }

    /**
     * Llama a la función para traerse los datos de ayuda y pinta la info en el popover del botón.
     */
    function getHelp() {
      scope.scriptHelpFunction = scope.scriptHelp ? scope.scriptHelp : ecFormBuilderController.dispatcher.get(attrs.scriptHelp);
      scope.scriptHelpFunction().then(data => {
        scope.functions = [];
        const jsonTemplate = fbScriptHelpTemplate(data, LOCALES, scope);

        const eDiv = document.querySelector('div[help-script]');
        eDiv.innerHTML = jsonTemplate;
        fakeButtons = eDiv.querySelectorAll('div[fake-button]');
        fakeButtons.forEach(button => {
          button.addEventListener('click', onAddFunction);
        });
        $compile(eDiv)(scope);
        unbinds.push(scope.$watch('searchFunction', inputChange));
        eFilterList = document.querySelector('[filter-list]');
        eFilterList.addEventListener('click', selectItem);
        eMenuSwap = document.querySelector('ewc-menu-swap');
      });
    }

    /**
     * LLama a la función de validación, ésta devuelve una promesa y en base a ella se sacan los alerts con la validación.
     */
    function validateScript() {
      scope.scriptValidatorFunction = scope.scriptValidator ? scope.scriptValidator : ecFormBuilderController.dispatcher.get(attrs.scriptValidator);
      scope.scriptValidatorFunction(scope.ngModel).then(data => {
        !data.length
          ? ecNotificationsService.alertSuccess({ title: "{{'fbScript.okValidation' | translate}}", content: "{{'fbScript.okValidationDescription' | translate}}" })
          : ecNotificationsService.boxMessageDanger({
              template: `<h1>{{'fbScript.koValidation' | translate}}</h1>
                <br>${data.map(child => `<p>${child}</p>`).join('')}`,
            });
      });
    }

    /**
     * Función que se llama en el evento de cambio del objeto del input.
     */
    function inputChange() {
      scope.showFunctionsList = !!scope.searchFunction.length;
      const filteredItems = scope.functions.filter(mapFunction => mapFunction.toLowerCase().indexOf(scope.searchFunction.toLowerCase()) > -1);

      eFilterList.innerHTML = getFunctionsList(filteredItems);
    }

    /**
     * Función que convierte la lista de funciones filtradas en una lista HTML.
     * @param {Array} filteredItems
     * @returns String Lista HTML de las funciones filtradas.
     */
    function getFunctionsList(filteredItems) {
      return `<ul ec-nostyle style="cursor: default">
                ${filteredItems
                  .map(
                    item => `
                  <li ec-padding index="${scope.functions.indexOf(item)}" map-function="${item}">
                    ${item}
                  </li>
                `
                  )
                  .join('')}
              </ul>`;
    }

    /**
     * Función que se llama al hacer click sobre una función de la lista.
     * Llamamos a un menú del swap.
     * @param {Object} event
     */
    function selectItem(event) {
      const target = event.target.closest('[index]');

      if (!target) {
        return;
      }

      const mapFunction = target.getAttribute('index');
      eMenuSwap.api.set(mapFunction);
      scope.showFunctionsList = false;
      scope.searchFunction = '';
      scope.$evalAsync();
    }

    /**
     * Función que pasándole el evento, busca la funcióna añadir y hace un insert en el script de la misma.
     * @param {Object} event
     */
    function onAddFunction(event) {
      const target = event.target.closest('[declaration]');

      if (!target) {
        return;
      }

      const action = target.getAttribute('declaration');
      scope.insert(action);
      document.querySelector('div[help-script]').parentElement.parentElement.hide();
    }

    function translate() {
      $translate(['fbScript.addFunction', 'fbScript.examples', 'fbScript.search']).then(translations => (LOCALES = translations));
    }
  }
}
